const SubsystemTypes = {
  1: "BLUETOOTH",
  2: "ALARM_BASE",
  3: "CHARGER_BASE",
  4: "WATCH_BASE",
  5: "WATCH_INTERFACE",
  6: "TRINKET",
  7: "NAVIGATION_MODULE",
  8: "BLUETOOTH_WATCHES",
  9: "FUEL_SENSOR",
  10: "BMW_BYPASS_MAIN",
  11: "TESTER",
  12: "CAN_MODULE_STM32H563IIK",
  13: "MICROBOT",
};
Object.freeze(SubsystemTypes);

const SubsystemTypesByName = {
  "BLUETOOTH": 1,
  "ALARM_BASE": 2,
  "CHARGER_BASE": 3,
  "WATCH_BASE": 4,
  "WATCH_INTERFACE": 5,
  "TRINKET": 6,
  "NAVIGATION_MODULE": 7,
  "BLUETOOTH_WATCHES": 8,
  "FUEL_SENSOR": 9,
  "BMW_BYPASS_MAIN": 10,
  "TESTER": 11,
  "CAN_MODULE_STM32H563IIK": 12,
  "MICROBOT": 13,
};
Object.freeze(SubsystemTypesByName);

export { SubsystemTypes, SubsystemTypesByName };
